import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { SettingsIcons } from "../../assets/images";
import CustomImageUpload from "../Clients/custom-image-upload";

interface Props {
  show?: boolean;
  setShow?: any;
  bgImage: boolean;
  setBgImage: any;
  imagePreview: string;
  setImagePreview: any;
  imageBGPreview: string;
  setImageBGPreview: any;
  companyNameEnglish?: string;
  setCompanyNameEnglish?: any;
  companyNameArabic?: string;
  setCompanyNameArabic?: any;
  companyPhone?: string;
  setCompanyPhone?: any;
  companyWebsite?: string;
  setCompanyWebsite?: any;
  companyEmail?: string;
  setCompanyEmail?: any;
  companyAddress?: string;
  setCompanyAddress?: any;
  payslip?: boolean;
}

const CustomInvoiceLetterHeadModal = ({
  show,
  setShow,
  bgImage,
  setBgImage,
  imageBGPreview,
  imagePreview,
  setImageBGPreview,
  setImagePreview,
  companyNameEnglish,
  setCompanyNameEnglish,
  companyNameArabic,
  setCompanyNameArabic,
  companyPhone,
  setCompanyPhone,
  companyWebsite,
  setCompanyWebsite,
  companyEmail,
  setCompanyEmail,
  companyAddress,
  setCompanyAddress,
  payslip,
}: Props) => {
  return (
    <>
      <Modal
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        className="general-modal"
      >
        <Modal.Body className="text-center px-5">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h4 className="heading">Custom Letter Head</h4>
            <button className="btn p-0 border-0" onClick={() => setShow(false)}>
              <img src={SettingsIcons.CrossIcon} alt="edit-icon" />
            </button>
          </div>
          <div className="change-password">
            <Row>
              <Col sm="6">
                <Form.Group
                  className="mb-3 text-start"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "18px" }}
                  >
                    Company Name in English
                  </h4>
                  <Form.Control
                    type="text"
                    name="companyNameEnglish"
                    placeholder="Enter company name in English"
                    onChange={(e) => setCompanyNameEnglish(e.target.value)}
                    value={companyNameEnglish}
                    className="custom-input border-fill"
                  />
                </Form.Group>
              </Col>
              {/*{!payslip && (*/}
              {/*  <>*/}
              <Col sm="6">
                <Form.Group
                  className="mb-3 text-start"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "18px" }}
                  >
                    Company Name in Arabic
                  </h4>
                  <Form.Control
                    type="text"
                    name="companyNameArabic"
                    placeholder="Enter company name in Arabic"
                    onChange={(e) => setCompanyNameArabic(e.target.value)}
                    value={companyNameArabic}
                    className="custom-input border-fill"
                  />
                </Form.Group>
              </Col>
              <Col sm="6">
                <Form.Group
                  className="mb-3 text-start"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "18px" }}
                  >
                    Company Phone
                  </h4>
                  <Form.Control
                    type="text"
                    name="companyPhone"
                    placeholder="Enter company phone number"
                    onChange={(e) => setCompanyPhone(e.target.value)}
                    value={companyPhone}
                    className="custom-input border-fill"
                  />
                </Form.Group>
              </Col>
              <Col sm="6">
                <Form.Group
                  className="mb-3 text-start"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "18px" }}
                  >
                    Company Website
                  </h4>
                  <Form.Control
                    type="text"
                    name="companyWebsite"
                    placeholder="Enter company website URL"
                    onChange={(e) => setCompanyWebsite(e.target.value)}
                    value={companyWebsite}
                    className="custom-input border-fill"
                  />
                </Form.Group>
              </Col>
              <Col sm="6">
                <Form.Group
                  className="mb-3 text-start"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "18px" }}
                  >
                    Company Email
                  </h4>
                  <Form.Control
                    type="email"
                    name="companyEmail"
                    placeholder="Enter company email address"
                    onChange={(e) => setCompanyEmail(e.target.value)}
                    value={companyEmail}
                    className="custom-input border-fill"
                  />
                </Form.Group>
              </Col>
              <Col sm="6">
                <Form.Group
                  className="mb-3 text-start"
                  controlId="formBasicEmail"
                >
                  <h4
                    className="sub-heading normal-font-weight textBlack"
                    style={{ fontSize: "18px" }}
                  >
                    Company Address
                  </h4>
                  <Form.Control
                    type="text"
                    name="companyAddress"
                    placeholder="Enter company address"
                    onChange={(e) => setCompanyAddress(e.target.value)}
                    value={companyAddress}
                    className="custom-input border-fill"
                  />
                </Form.Group>
              </Col>
              {/*  </>*/}
              {/*)}*/}
              <Col sm="12">
                <CustomImageUpload
                  bgImage={bgImage}
                  setBgImage={setBgImage}
                  imagePreview={imagePreview}
                  setImagePreview={setImagePreview}
                  imageBGPreview={imageBGPreview}
                  setImageBGPreview={setImageBGPreview}
                />
              </Col>
            </Row>
            <div className="mt-4">
              <button
                className="btn primary-button text-center w-25 me-2"
                onClick={() => {
                  setShow(false);
                }}
                type="button"
              >
                Cancel
              </button>
              <button
                className="btn primary-button text-center w-25"
                onClick={() => setShow(false)}
                type="button"
              >
                Save
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CustomInvoiceLetterHeadModal;
